import React from 'react';
import PropTypes from 'prop-types';

import { CONTENT_POSITION_TYPES } from '@/constants';
import { usePageProps } from '@/hooks';

import { Inner, Link, Title, Wrapper } from './styles';

function Menu({
  items,
  position,
  caption,
  locationPath = `${process.env.APP_ROUTER_BASENAME}/`,
}) {
  const pageProps = usePageProps();
  const { location } = pageProps;

  if (!items?.length) {
    return null;
  }

  const isDefaultStyles = position !== CONTENT_POSITION_TYPES.headerBottom;
  const isBottomLinkBlocksStyles =
    position === CONTENT_POSITION_TYPES.contentBottom;

  const getIsActiveRoure = (route, pathName) =>
    `${locationPath}${pathName}/` === `${route}/`;

  return (
    <Wrapper
      $defaultStyles={isDefaultStyles}
      $isBottomLinkBlocksStyles={isBottomLinkBlocksStyles}
    >
      <Inner
        $defaultStyles={isDefaultStyles}
        $isBottomLinkBlocksStyles={isBottomLinkBlocksStyles}
      >
        {isDefaultStyles && <Title>{caption}</Title>}
        {items?.map(({ title: itemTitle, url, blank }) => {
          const isActive = getIsActiveRoure(url, location.pathname);

          return (
            <Link
              $defaultStyles={isDefaultStyles}
              title={itemTitle}
              key={url}
              className={isActive && 'active'}
              href={url}
              target={blank}
              dangerouslySetInnerHTML={{ __html: itemTitle }}
            />
          );
        })}
      </Inner>
    </Wrapper>
  );
}

Menu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  position: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  locationPath: PropTypes.string,
};

export default Menu;
